import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import Header from '../components/Header';
import usePageMeta from '../utils/usePageMeta';

const InvalidLeaguePage = () => {
  usePageMeta({
    title: 'League Not Found',
    description: 'The league you are trying to access does not exist or is invalid.',
  });

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <Header />

      {/* Hero Band */}
      <div className="bg-forest border-b-4 border-mustard">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-8 h-8 text-mustard flex-shrink-0" aria-hidden="true" />
            <h1 className="font-display text-4xl font-black text-white leading-none">
              League Not Found
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 py-12">
        <div className="bg-surface border border-border-card rounded-card shadow-card p-8 max-w-xl">
          <p className="text-ds-text font-sans text-base leading-relaxed mb-2">
            The league you are trying to access does not exist or is invalid. Please verify the league information and try again.
          </p>
          <p className="text-text-muted font-sans text-sm mb-6">
            Thank you for your understanding.
          </p>
          <Link
            to="/dashboard"
            className="inline-block px-5 py-2.5 bg-mustard text-forest font-sans font-extrabold text-sm rounded-lg shadow-mustard hover:bg-yellow-500 transition-colors"
          >
            Back to Dashboard
          </Link>
        </div>
      </main>
    </div>
  );
};

export default InvalidLeaguePage;
